import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import moment from 'moment';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';


import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Cerrar from "./Cerrar.js"
import EnviarUVT from "./EnviarUVT.js"
import Aceptar from "./Aceptar.js"
import ModificarPlan from "./ModificarPlan.js"
import Rechazar from "./Rechazar.js"
import Avanzar from "./Avanzar.js"
import Asignar from "./Asignar.js"

import PresupuestoFormal from "./PresupuestoFormal.js"
import DocumentosPresupuesto from "./DocumentosPresupuesto.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"
import DateFilter from "../../../components/ParadigmaTable/DateFilter";


import Enums from "../EstadoEnum.js"

import dateFunctions from '../../functions/dateFunctions';

class Presupuesto extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 70,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro. Presupuesto",
                    id: "cod",
                    width: 150,
                    accessor: d => (d.cod != null ? d.cod.toUpperCase() : d.plan__solicitud__codigo.toUpperCase()),
                    show: true,
                },
                /*{
                    Header: "cantEtapas",
                    id: "cantEtapas",
                    accessor: "cantEtapas",
                    show: false,
                    private:true,
                },*/
                {
                    Header: "Etapas",
                    id: "etapa",
                    width: 50,
                    // accessor: (d)=> (d.etapa && d.cantEtapas) ? ((d.cantEtapas!=1) ? (d.etapa + '/' + d.cantEtapas) : ('-')) : ('-'),
                    accessor: (d) => (d.etapa && d.etapa>0) ? (d.etapa) : ('-'),
                    show: true,
                    className: "text-center",
                },
                {
                    Header: "Código Interno",
                    id: "plan__solicitud__codigo",
                    accessor: "plan__solicitud__codigo",
                    show: false,
                    private: true,
                },
                {
                    Header: "Fecha",
                    id: "fecha",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fecha),
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />
                },
                {
                    Header: "Título",
                    id: "plan__solicitud__nombre",
                    accessor: "plan__solicitud__nombre",
                    show: true,
                },
                {
                    Header: "Empresa/Organización",
                    id: "plan__solicitud__empresa__nombre",
                    accessor: d => d.plan__solicitud__empresa__nombre,
                    show: true,
                },
                {
                    Header: "OTT",
                    id: "ott__nombre",
                    accessor: d => d.ott__nombre,
                    show: true,
                },
                {
                    Header: "UVT",
                    id: "uvt__nombre",
                    accessor: d => d.uvt__nombre,
                    show: true,
                },
                {
                    Header: "Valor Final",
                    id: "valorfinal",
                    accessor: d => (d.valorfinal % 1 == 0) ? (dateFunctions.formatCurrencySDecimales(d.valorfinal)) : (dateFunctions.formatCurrency(d.valorfinal)),
                    className: "text-right",
                    show: true,
                },
                {
                    Header: "Moneda",
                    id: "condiciondepago__nombre",
                    accessor: "condiciondepago__nombre",
                    width: 80,
                    show: true,
                },
                {
                    Header: "LTE",
                    id: "lae_full",
                    accessor: d => d.lae_full,
                    show: true,
                },
                {
                    Header: "Observaciones",
                    id: "observaciones",
                    accessor: d => d.observaciones,
                    show: true,
                },
                {
                    Header: "hash_r",
                    id: "hash_r",
                    accessor: d => d.hash_r,
                    show: false,
                    private:true,
                },
                {
                    Header: "Reporte",
                    id: "reportable",
                    filterable: false,
                    accessor: d => (d.reportable ? api.proyectos.presupuesto.reporte + d.hash_r + "/" : ""),
                    show: true,
                    Cell: props => (props.value != '' ? <a target={"_blank"} href={props.value}>DESCARGAR</a> : ''),
                    width: 100,
                },
                {
                    Header: "fechaEnviadoUVT",
                    id: "fechaEnviadoUVT",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEnviadoUVT),
                    show: false,
                    private: true
                },
                {
                    Header: "fechaEnviadoOTT",
                    id: "fechaEnviadoOTT",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEnviadoOTT),
                    show: false,
                    private: true
                },
                {
                    Header: "FechaEstado",
                    id: "fechaEstado",
                    className: "text-center",
                    accessor: d => dateFunctions.parseDateTime(d.fechaEstado),
                    show: false,
                    private: true
                },
                {
                    Header: "Estado",
                    id: "strestado",
                    show: true,
                    className: "text-center",
                    width: 200,
                    Filter: ({ filter, onChange }) =>
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : "TODOS"}>
                            <option value="">TODOS</option>
                            <option value="PRESUPUESTANDO">PRESUPUESTANDO</option>
                            <option value="PRESUPUESTO RECHAZADO">PRESUPUESTO RECHAZADO</option>
                            <option value="PRESUPUESTO ACEPTADO">PRESUPUESTO ACEPTADO</option>
                            <option value="PRESUPUESTO ENVIADO">PRESUPUESTO ENVIADO</option>
                        </select>,
                    accessor: d => {
                        if (d.plan__solicitud__codigo.startsWith("V-"))
                            if (d.strestado == "PRESUPUESTANDO")
                                return (<div className="badge badge-warning presupuestoStateLabel">{d.strestado}
                                <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                                </div>);
                            else if (d.strestado == "PRESUPUESTO ACEPTADO")
                                return (<div className="badge badge-success presupuestoStateLabel">{"VALE ACEPTADO"}
                                <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                                </div>);
                            else if (d.strestado == "PRESUPUESTO RECHAZADO")
                                return (<div className="badge badge-danger presupuestoStateLabel">{"VALE RECHAZADO"}
                                <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                                </div>);
                            else
                                return (<div className="badge badge-primary presupuestoStateLabel">{d.strestado.replace("PRESUPUESTO", "VALE")}
                                    <br></br> <small>{dateFunctions.parseDateTime(d.strestado.indexOf('OTT') == -1 ? d.fechaEnviadoUVT : d.fechaEnviadoOTT)}</small>
                                </div>);
                        else
                            if (d.strestado == "PRESUPUESTANDO")
                                return (<div className="badge badge-warning presupuestoStateLabel">{d.strestado}
                                <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                                </div>);
                            else if (d.strestado == "PRESUPUESTO ACEPTADO")
                                return (<div className="badge badge-success presupuestoStateLabel">{d.strestado}
                                <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                                </div>);
                            else if (d.strestado == "PRESUPUESTO RECHAZADO")
                                return (<div className="badge badge-danger presupuestoStateLabel">{d.strestado}
                                <br></br> <small>{dateFunctions.parseDateTime(d.fechaEstado)}</small>
                                </div>);
                            else
                                return (<div className="badge badge-primary presupuestoStateLabel">{d.strestado}
                                    <br></br> <small>{dateFunctions.parseDateTime(d.strestado.indexOf('OTT') == -1 ? d.fechaEnviadoUVT : d.fechaEnviadoOTT)}</small>
                                </div>);
                    },
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        edit: true,
                        permission: 'presupuestos_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'presupuestos_detail',
                        component: Detail,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_cerrar',
                        component: Cerrar,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_enviaruvt',
                        component: EnviarUVT,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_asignar',
                        component: Asignar,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_modify',
                        component: ModificarPlan,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_aceptar',
                        component: Aceptar,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_rechazar',
                        component: Rechazar,
                    },
                    {
                        edit: true,
                        permission: 'presupuestos_next',
                        component: Avanzar,
                    },
                    /*{
                        edit: true,
                        permission: 'presupuestos_formal',
                        component: PresupuestoFormal,
                    },*/
                    {
                        edit: true,
                        permission: 'presupuestos_documentos',
                        component: DocumentosPresupuesto,
                    },
                ]}

                apiUrl={api.proyectos.presupuesto.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.presupuesto.export}
                title={"Presupuestos"}
            />
        );
    }
}

export default Presupuesto;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento3/Presupuesto.js